module.exports = __webpack_public_path__ + "fonts/Young.7c3b6ad9.eot";